module.exports = __webpack_public_path__ + "static/media/hero.9f089f11.png";